import NotFound from '@/views/404'
const routers = [
  {
    path: '/404',
    name: 'NotFound',
    meta: {
      title: '页面不见啦！'
    },
    component: NotFound
  },
  {
    path: '*',
    redirect: {
      name: 'NotFound'
    }
  }
]

setNotInMenu(routers)

const routersNames = getList(routers)

function setNotInMenu (data) {
  if (Array.isArray(data)) {
    return data.map(ob => {
      if (typeof ob === 'object') {
        return caseDataObject (ob)
      }
    })
  } else if (typeof data === 'object') {
    return caseDataObject (data)
  }
}

function caseDataObject (data) {
  try {
    if (data.hasOwnProperty('meta')) {
      data.meta.inMenu = false
    } else {
      data.meta = {
        inMenu: false
      }
    }
    data.hasOwnProperty('children') && setNotInMenu(data.children)
  } catch (e) {
    console.error(e)
  }
  return data
}

function getList (data) {
  const list = []
  if (Array.isArray(data)) {
    data.map(ob => {
      if (typeof ob === 'object') {
        ob.hasOwnProperty('name') && list.push(ob.name)
        ob.hasOwnProperty('children') && list.push(...getList(ob.children))
      }
    })
  } else if (typeof data === 'object' && data.hasOwnProperty('name')) {
    data.hasOwnProperty('name') && list.push(data.name)
    data.hasOwnProperty('children') && list.push(...getList(data.children))
  }
  return list
}

export default routers
export {
  routers,
  routersNames
}
